export default __webpack_public_path__ + "static/media/08.56.266e0006.jpg";